module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "unAt2tYZfDys5tSPYYdTaQG"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Dedicated to those of us who were ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("taught to feel afraid.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("WE ARE")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("More than a slur spoken in passing.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("More than an object of illicit desire.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("More than a way to vent their anger.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("We are deserving of protection.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("AND THEIR GAZE CANNOT DIMINISH US.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f1ae7e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stsebastianepub_split3.vue
// module id = 66
// module chunks = 0